<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
  ><g><g><path
    :fill="color"
    d="M8.69 4.26l-.683-.683-1.612 1.612V.5H5.42V5.19L3.807 3.577l-.684.684 2.784 2.783zm2.124 3.124h-.977v2.442h-7.86V7.384H1v3.418h9.814z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="50"
    stroke-width=".5"
    d="M8.69 4.26l-.683-.683-1.612 1.612V.5H5.42V5.19L3.807 3.577l-.684.684 2.784 2.783zm2.124 3.124h-.977v2.442h-7.86V7.384H1v3.418h9.814z"
  /></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
